import { useMutation } from '@tanstack/react-query';

import type { DiscountReasonMutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useDiscountReasonActionMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<DiscountReasonMutationResponse>({
        method: 'PATCH',
        url,
      }),
  });
